import { type GroupBase, type SelectComponentsConfig, components } from 'react-select';

import { LanguageDisplay } from '../LanguageDisplay/LanguageDisplay';

export const Placeholder: SelectComponentsConfig<
  { name: string; id: string },
  false,
  GroupBase<{ name: string; id: string }>
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
>['Placeholder'] = ({ children, ...props }) => (
  <components.Placeholder {...props}>
    <LanguageDisplay type="placeholder" />
  </components.Placeholder>
);
